
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 3.333c.368 0 .667.299.667.667v8H1.333V4c0-.368.299-.667.667-.667h12zM2 10.667v.666h12v-.666H2zM2 10h12V4H2v6zm8.667 2.667v.666H5.333v-.666h5.334z","fill":"#71798A","fill-rule":"nonzero"}})])
          )
        }
      }
    